import Debug from 'debug'
import Policy from './Policy.js'

const debug = Debug('cbio.policies')

export default (api) => ({

  current: async (query, options) => {
    debug('current()')
    return new Policy(api, await api.fetch(Policy.url({ id: 'current' }), query, options))
  }

})

export { Policy }
